export const kbmslogo         = require('./kbms-logo.png');
// export const utipaymngheader  = require('./utipay-mng-header.png');
